import { createNewHandbookApi } from '@/api/handbookApi'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'
import { CATALOG_URL } from '@/api/catalog'

const PRODUCT_TYPE_URL = `${CATALOG_URL}/product-types`

const errors = createHandbookResponseErrors('тип продукции', 'типов продукции')

export const ProductTypeApi = createNewHandbookApi(PRODUCT_TYPE_URL, errors)
